import moment from "moment";

export const formatLeadsPayload = (endPoint, payload, userId) => {
  let url = `${endPoint}?sort=lastModifiedDate,desc&page=${payload?.page ? payload?.page : 0}&size=${payload?.size ? payload?.size : 10}`;
  if (payload?.Countries) {
    url = `${url}&country.in=${payload?.Countries}`;
  }
  if (payload?.States) {
    url = `${url}&state.in=${payload?.States}`;
  }
  if (payload?.Cities) {
    url = `${url}&city.in=${payload?.Cities}`;
  }
  if (payload?.Industry) {
    url = `${url}&industryId.in=${payload?.Industry}`;
  }
  if (payload?.companyName) {
    url = `${url}&companyName.contains=${payload?.companyName}`;
  }
  if (payload?.["Lead Time"]) {
    const items = payload?.["Lead Time"].split(",");
    let startDateTime = null;
    let endDateTime = null;

    if (items.includes("This Year")) {
      startDateTime = moment().startOf("year");
      endDateTime = moment().endOf("year");
    } else if (items.includes("This Month")) {
      startDateTime = moment().startOf("month");
      endDateTime = moment().endOf("month");
    } else if (items.includes("Last 7 days")) {
      startDateTime = moment().subtract(6, "days").startOf("day");
      endDateTime = moment().endOf("day");
    } else if (items.includes("Yesterday") && items.includes("Today")) {
      startDateTime = moment().subtract(1, "day").startOf("day");
      endDateTime = moment().endOf("day");
    } else if (items.includes("Yesterday")) {
      startDateTime = moment().subtract(1, "day").startOf("day");
      endDateTime = moment().subtract(1, "day").endOf("day");
    } else if (items.includes("Today")) {
      startDateTime = moment().startOf("day");
      endDateTime = moment().endOf("day");
    } else {
    }
    url = `${url}&lastModifiedDate.greaterThanOrEqual=${startDateTime.utc().format()}&lastModifiedDate.lessThanOrEqual=${endDateTime.utc().format()}`;
  }
  if (payload?.startDate && payload?.endDate) {
    url = `${url}&lastModifiedDate.greaterThanOrEqual=${payload?.startDate}&lastModifiedDate.lessThanOrEqual=${payload?.endDate}`;
  }
  if (payload?.["Employee Size"]) {
    url = `${url}&rangeId.in=${payload?.["Employee Size"]}`;
  }
  if (payload?.["Lead Status"]) {
    url = `${url}&statusId.in=${payload?.["Lead Status"]}`;
  }
  if (payload?.["Lead Rating"]) {
    url = `${url}&leadRating.in=${payload?.["Lead Rating"]}`;
  }
  if (payload?.designation) {
    url = `${url}&title.contains=${payload?.designation}`;
  }
  if (payload?.ownerName || userId) {
    url = `${url}&userId.equals=${payload?.ownerName || userId}`;
  }
  if (payload?.firstName) {
    url = `${url}&firstname.contains=${payload?.firstName}`;
  }
  if (payload?.lastName) {
    url = `${url}&lastname.contains=${payload?.lastName}`;
  }
  if (payload?.searchKeyword) {
    url = `${url}&term=${payload?.searchKeyword}`;
  }
  if (payload?.zipCode) {
    url = `${url}&zipcode.contains=${payload?.zipCode}`;
  }
  if (payload?.leadSource) {
    url = `${url}&leadSource.contains=${payload?.leadSource}`;
  }
  if (payload?.Tags) {
    url = `${url}&tags.equals=${payload?.Tags}`;
  }
  if (payload?.["Notes Tags"]) {
    url = `${url}&noteTags.in=${payload?.["Notes Tags"]}`;
  }
  return url;
};
